// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://kecnrwelghxnsegpmjpu.supabase.co"; // Replace with your Supabase URL
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtlY25yd2VsZ2h4bnNlZ3BtanB1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjY1OTAzNjcsImV4cCI6MjA0MjE2NjM2N30.BUHTzjYRz4BhiiLdrjMJVjuAPVBo8Cl3TtVWs2LolW8"; // Replace with your Supabase anon key
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
